import { ApiError, type ApiFieldError } from './api'

/** Кириллица в тексте — признак сообщения, предназначенного пользователю (issue #7). */
const HAS_CYRILLIC = /[А-Яа-яЁё]/

/**
 * Человекочитаемое сообщение из любой ошибки (для вывода в формах).
 *
 * В русском интерфейсе не должно появляться английских служебных текстов (issue #7):
 * сообщения API уже русские, а вот у обычных `Error` сообщение часто приходит от браузера
 * или библиотеки («Failed to fetch», «NetworkError when attempting to fetch resource»).
 * Такие тексты пользователю ничего не объясняют, поэтому вместо них показывается
 * осмысленный русский `fallback`, а исходная ошибка остаётся доступной в консоли/логах.
 */
export function getErrorMessage(err: unknown, fallback = 'Что-то пошло не так'): string {
  if (err instanceof ApiError) return err.message || fallback
  if (err instanceof Error && HAS_CYRILLIC.test(err.message)) return err.message
  return fallback
}

/** Сообщение об ошибке по полю (если бэкенд вернул details валидации). */
export function fieldError(err: unknown, field: string): string | undefined {
  if (err instanceof ApiError && err.details) {
    return err.details.find((d: ApiFieldError) => d.field === field)?.message
  }
  return undefined
}
